/* eslint-disable react-hooks/exhaustive-deps */
'use client'

import { Button, Input } from '@populix/pop-ui'

import useLoginForm from './use-login-form'

const LoginForm = () => {
  const { formik, handleInputChange, ref, isFetching } = useLoginForm()

  return (
    <form
      className='flex flex-col gap-3'
      onSubmit={formik.handleSubmit}
      data-testid='login-form'
      ref={ref}
    >
      <div className='sentry-mask'>
        <Input
          {...formik.getFieldProps('username')}
          type='text'
          caption='Email Address or Phone Number'
          label='Enter your credential'
          onChange={handleInputChange}
          error={formik.errors?.username}
          id='username-field'
        />
      </div>
      <Button type='submit' variant='contained' color='primary' disabled={isFetching}>
        Log In
      </Button>
    </form>
  )
}

export default LoginForm
